import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory, useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import CardText from "components/Card/CardText";

import Button from "components/CustomButtons/Button";

import { actionCreators as actionCreatorsChapter } from "../../../_actions/chapterActions";
import Loading from "../../common/Loading";
import MailLogView from "./MailLog";

const useStyles = makeStyles(theme => ({
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2)
  },
  marginTop: {
    marginTop: theme.spacing(3)
  },
  marginBottom: {
    marginBottom: theme.spacing(3)
  }
}));

const FinancialReportMailLogView = props => {
  const classes = useStyles();
  const { id } = useParams();
  const history = useHistory();

  const { getChapterFinancial, activeChapterFinancial, isFetching, isFetched } =
    props;

  useEffect(() => {
    if (!isFetching.CHAPTER_FINANCIAL && !isFetched.CHAPTER_FINANCIAL) {
      getChapterFinancial(id);
    }
  }, [isFetching, isFetched, id]);

  const handleBackToReport = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <Container>
      <Card>
        <CardHeader color="rose" text>
          <CardText color="rose">
            <Typography variant="h4">
              {activeChapterFinancial != null && (
                <span>
                  Mail Log For {activeChapterFinancial.chapter.name} FY{" "}
                  {activeChapterFinancial.year} Report
                </span>
              )}
            </Typography>
          </CardText>
        </CardHeader>
        <CardBody>
          <Paper className={classes.paper}>
            {!activeChapterFinancial ? (
              <Loading />
            ) : (
              <Grid container justify="center" alignItems="center">
                <Grid item xs={12} md={6}>
                  <Grid container justify="space-between">
                    <Grid item>
                      <Button color="primary" simple>
                        Download PDF
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        color="primary"
                        simple
                        onClick={handleBackToReport}
                      >
                        Back To Report
                      </Button>
                    </Grid>
                  </Grid>
                  <Divider className={classes.marginBottom} />
                  {activeChapterFinancial.mailLog.map(mail => {
                    return <MailLogView {...mail} key={`mail-${mail.id}`} />;
                  })}
                </Grid>
              </Grid>
            )}
          </Paper>
        </CardBody>
      </Card>
    </Container>
  );
};

const mapStateToProps = state => ({
  isFetching: state.chapterReducer.isFetching,
  isFetched: state.chapterReducer.isFetched,
  activeChapterFinancial: state.chapterReducer.activeChapterFinancial
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreatorsChapter }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinancialReportMailLogView);
